import { PathGenerator } from "./Game Map/PathGenerator";
import { View } from "./View/View";
import { Player } from "./Player/Player";
import { MapRow } from "./Game Map/MapRow";
import { TileBase } from "./Ground Tiles/TileBase";
import { ObstacleManager } from "./Obstacles/ObstacleManager";
import { BonusManager } from "./Bonuses/BonusManager";
import { PlatformManager } from "./Platforms/PlatformManager";
import { Background } from "./Background/Background";
import { Checkpoint } from "../Checkpoint";



export class GameWorld {
    /**
     * Pozice zacatku herniho sveta na ose X (levy okraj prvni dlazdice)
     */
    static readonly X = 0;

    /**
     * Pozice povrchu zeme na ose Y
     */
    static readonly GROUND_Y = 0;

    /**
     * Pozice falesnych stinu na ose Y
     */
    static readonly SHADOW_Y = 0.001;

    /**
    * Pozice zacatku herniho sveta na ose Z (spodni okraj dlazdice prvni radky)
    */
    static readonly Z = 0;

    /**
     * Pozice stredu herniho sveta na ose X
     */
    static readonly CENTER_X = GameWorld.X + (MapRow.WIDTH / 2) * TileBase.SIZE;

    /**
     * (RO) Staticky pristup
     */
    static get instance(): GameWorld { return GameWorld._instance; }
    private static _instance: GameWorld;

    /**
     * (RO) Generator cesty
     */
    get pathGenerator(): PathGenerator { return this._pathGenerator; }
    private _pathGenerator: PathGenerator;

    /**
     * (RO) Hrac
     */
    get player(): Player { return this._player; }
    private _player: Player;

    /**
     * (RO) Spravce prekazek
     */
    get obstacles(): ObstacleManager { return this._obstacles; }
    private _obstacles: ObstacleManager;

    /**
     * (RO) Spravce bonusu
     */
    get bonuses(): BonusManager { return this._bonuses; }
    private _bonuses: BonusManager;

    /**
     * (RO) Spravce pojizdnych plosin
     */
    get platforms(): PlatformManager { return this._platforms; }
    private _platforms: PlatformManager;

    /**
     * Pozadi
     */
    private _bg: Background;

    /**
     * (RO) Pohled do herniho sveta
     */
    get view(): View { return this._view; }
    private _view: View;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        GameWorld._instance = this;

        this._player = new Player();
        this._obstacles = new ObstacleManager();
        this._bonuses = new BonusManager();
        this._platforms = new PlatformManager();
        this._pathGenerator = new PathGenerator();
        this._bg = new Background();
        this._view = new View(this._player);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(restartFromCP: boolean = false): void {
        if (!restartFromCP) {
            // Generator cesty resetov pred hracem
            this._pathGenerator.reset(this._pathGenerator.samePathRestartCnt >= 3 ? -1 : 0);

            // Resetovat hrace
            this._player.reset();
        }
        else {
            this._pathGenerator.reset(this._player.checkpoint.pathEntryId);
            this._player.restartFromCP();
        }

        // Resetovat prekazky, bonusy, plosiny
        this._obstacles.reset();
        this._bonuses.reset();
        this._platforms.reset();

        // View        
        this._view.reset();
        this._bg.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._platforms.update();   // Plosiny aktualizovat pred hracem
        this._player.update();
        this._view.update();
        this._obstacles.update();
        this._bonuses.update();
        this._bg.update();
    }
}